import React, { Fragment, useState, useEffect } from 'react';
import { constEvent } from '../../utils/constants';
import { dispatchGenericEvent } from '../../utils/dispatch-events';
import axios from 'axios';
import serialize from 'form-serialize';
import MicroModal from 'micromodal';
import Pristine from 'pristinejs';

import {
  SERIALIZE_SETTINGS,
  PRISTINE_SETTINGS
} from '../../utils/default-settings';

const SpecificlotinfoSearch = () => {
  const [errorMessage, setErrorMessage] = useState(null);
  const [data, setData] = useState(null);
  const [tableBody, setTableBody] = useState(null);
  const [page, setPage] = useState(1);
  const [isValidForm, setIsValidForm] = useState(true);
  const [selectedLots, setSelectedLots] = useState({});
  const [atccNumber, setAtccNumber] = useState(null);
  const [lotNumberForModal, setLotNumberForModal] = useState(null);

  useEffect(() => {
    const handleSpecificLotBtn = event => {
      const target = event.target;
      const modalTrigger = target.closest('.pdp-page [data-generic-modal-open="modal-lot-information"]');
      if (modalTrigger) {
        const id = modalTrigger.getAttribute('data-generic-modal-open');
        if (id) {
          fetch(modalTrigger);
          MicroModal.show(id, {
            openTrigger: 'data-generic-modal-open',
            closeTrigger: 'data-generic-modal-close',
            openClass: 'generic-modal--open',
            disableScroll: true,
            disableFocus: true,
            awaitOpenAnimation: true,
            awaitCloseAnimation: true,
            onClose: () => modalCloseListener()
          });
        }
      }
    };

    document.addEventListener('click', handleSpecificLotBtn);

    return () => {
      document.removeEventListener('click', handleSpecificLotBtn);
    };
  }, []);

  useEffect(() => {
    if (data) {
      const isQuantityValid = data.some(item => item.quantity);

      const isInventoryValid = data.some(item => {
        const quantityValue = parseInt(item.quantity);
        const inventoryValue = parseInt(item.Inventory);
        return quantityValue > inventoryValue;
      });

      setIsValidForm(isQuantityValid && !isInventoryValid);
    }
  }, [data]);

  const handleQuantityChange = input => {
    const form = document.querySelector('.lot-quantity-form');
    const quantityInputs = form.querySelectorAll('input[name="quantity"]');
    const addToCartButton = document.getElementById('add-to-cart-button');
    let isFormValid = true;

    quantityInputs.forEach(input => {
      input.value = input.value.replace(/[^0-9]/g, '');

      const quantityValue = parseInt(input.value.trim(), 10);
      let isAnyQuantityExceedsInventory = false;
      if (quantityValue <= 0) {
        input.value = '';
        input.classList.add('error');
      } else {
        input.classList.remove('error');
      }

      data.forEach(item => {
        const inventoryValue = parseInt(data[input.dataset.index]?.Inventory, 10);
        if (quantityValue > inventoryValue) {
          input.classList.add('error-inventory');
          isAnyQuantityExceedsInventory = true;
          isFormValid = false;
        } else {
          input.classList.remove('error-inventory');
          if (addToCartButton) {
            addToCartButton.disabled = false;
          }
        }
      });

      const isAnyFieldFilled = Array.from(quantityInputs).some(input => input.value.trim() !== '');
      form.classList.toggle('error-quantity', !isAnyFieldFilled);

      const anyQuantityExceedsInventory = Array.from(quantityInputs).some(input => {
        const quantityValue = parseInt(input.value.trim(), 10);
        const inventoryValue = parseInt(data[input.dataset.index]?.Inventory, 10);
        return data.some(item => quantityValue > inventoryValue);
      });
      form.classList.toggle('error-inventory', anyQuantityExceedsInventory);

      quantityInputs.forEach(input => {
        if (!isAnyFieldFilled) {
          input.setAttribute('required', true);
          input.classList.add('error');
        } else {
          input.removeAttribute('required');
          input.classList.remove('error');
          if (addToCartButton) {
            addToCartButton.disabled = false;
          }
        }
      });

      setIsValidForm(isFormValid && isAnyFieldFilled && !isAnyQuantityExceedsInventory);
    });
  };

  const handleQuantityUpdate = (index, value) => {
    const values = [...data];
    values[index].quantity = value;
    setData(values);
  };

  const updateCartIndicator = itemsInCart => {
    const $cartItemsIndicator = document.querySelector('.header__items-in-cart');

    if ($cartItemsIndicator && itemsInCart) {
      $cartItemsIndicator.textContent = itemsInCart;
      $cartItemsIndicator.classList.remove('header__items-in-cart--hidden');
    }
  }; //updateCartIndicator

  const handleAddToCart = async event => {
    event.preventDefault();
    handleQuantityChange();

    const addToCartButton = document.getElementById('add-to-cart-button');

    if (isValidForm) {
      if (addToCartButton) {
        addToCartButton.disabled = true;
      }
      try {
        const form = document.querySelector('.lot-quantity-form');
        const cartEndpoint = form.getAttribute('cart-endpoint');
        const payload = {
          product_id: atccNumber,
          lotModel: data && data.length > 0 ?
            data.filter(({ quantity }) => parseInt(quantity) > 0)
              .map(({ LotNumber, quantity }) => ({
                lotNumber: LotNumber,
                quantity: parseInt(quantity)
              })) : []
        };

        const response = await axios.post(cartEndpoint, payload);
        console.log('Added to cart:', response.data);

        setSelectedLots({});
        MicroModal.close('modal-lot-information');

        const { success, body } = response.data || {};

        if (success) {
          const { dispatchEvent } = body || {};

          if (dispatchEvent) {
            dispatchGenericEvent(dispatchEvent, body);
          }

          if (addToCartButton) {
            addToCartButton.disabled = false;
          }
        } else {
          console.error('Error adding to cart');
        }

      } catch (error) {
        console.error('Error adding to cart:', error);
        if (addToCartButton) {
          addToCartButton.disabled = false;
        }
      }
    } else {
      console.log('Form is not valid.');
    }
  };

  useEffect(() => {
    const form = document.querySelector('.lot-quantity-form');

    if (form) {
      form.addEventListener('submit', handleAddToCart);
    }

    return () => {
      if (form) {
        form.removeEventListener('submit', handleAddToCart);
      }
    };
  }, [isValidForm]);

  useEffect(() => {
    if (data) {
      setPage(data?.page);
      setTableBody(data?.tableBody);
    }
  }, [data]);

  const fetch = async element => {
    const form = document.querySelector('.lot-quantity-form');
    const endpoint = form.getAttribute('endpoint').replace(/\/$/, '');
    const attcNum = element.getAttribute('data-atcc-number');
    setAtccNumber(attcNum);
    const id = element.getAttribute('data-generic-modal-open') || null;

    try {
      const response = await axios.get(`${endpoint}?atcc_number=${attcNum}`);
      const resList = [];
      response.data.forEach(res => {
        const resData = {
          quantity: '',
          LotNumber: res.LotNumber,
          Inventory: res.Inventory,
          DonorAge: res.DonorAge,
          DonorSex: res.DonorSex,
          DonorEthnicity: res.DonorEthnicity,
          DonorBMI: res.DonorBMI,
          url: res.url,
          CoA: res.CoA
        };
        resList.push(resData);
      });

      setData(resList);
      if (id) {
        MicroModal.show(id, {
          openTrigger: 'data-generic-modal-open',
          closeTrigger: 'data-generic-modal-close',
          openClass: 'generic-modal--open',
          disableScroll: true,
          disableFocus: true,
          awaitOpenAnimation: true,
          awaitCloseAnimation: true,
          onClose: () => modalCloseListener()
        });
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      setErrorMessage('Failed to fetch data');
    }
  };

  const modalCloseListener = () => {
    const form = document.querySelector('.lot-quantity-form');
    if (form) {
      form.reset();

      const quantityInputs = form.querySelectorAll('input[name="quantity"]');
      if (quantityInputs) {
        quantityInputs.forEach(input => {
          input.value = '';
        });
      }
      form.classList.remove('error-quantity');
      form.classList.remove('error-inventory');
    }
    setData(null);
  };

  useEffect(() => {
    const externalButton = document.querySelector('.product-listing__atc.fw-btn .btn--primary');
    if (externalButton) {
      externalButton.addEventListener('click', () => fetch(externalButton));
    }

    return () => {
      if (externalButton) {
        externalButton.removeEventListener('click', () => fetch(externalButton));
      }
    };

  }, []);

  useEffect(() => {
    document.addEventListener(
      constEvent.COVEO_RESULTS_UPDATED,
      handleCustomEvent
    );
    document.addEventListener(
      constEvent.COVEO_RESULTS_UPDATED_AJAX,
      handleCustomEvent
    );

    return () => {
      document.removeEventListener(
        constEvent.COVEO_RESULTS_UPDATED,
        handleCustomEvent
      );
      document.removeEventListener(
        constEvent.COVEO_RESULTS_UPDATED_AJAX,
        handleCustomEvent
      );
    };
  }, []);

  const handleCustomEvent = e => {
    const detail = e?.detail || null;
    if (!detail || !(typeof detail === 'string'))  return;

    const $buyNowWrapper = document.querySelector(`#${detail}`);
    if (!$buyNowWrapper) return;

    const element = $buyNowWrapper.querySelector('.product-listing__atc.fw-btn .btn--primary');
    if (element) {
      element.addEventListener('click', () => fetch(element));
    }

    return () => {
      if (element) {
        element.removeEventListener('click', () => fetch(element));
      }
    };
  };

  const customShowModal = (modalId, lotNumber, coaData) => {
    setLotNumberForModal(lotNumber);
    resetCoaRequestForm();
    const modal = document.getElementById(modalId);
    const modalCoo = modal.querySelector('.modal-certificate-analysis__coo');
    const modalCooRequest = modal.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__coo-request');
    const modalSuccess = document.querySelector('.modal-certificate-analysis__success');
    const lotNumberInput = modal.querySelector('.modal-certificate-analysis-hepatocyte input[name="lot_number"]');
    const requestDescription = modal.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__description');

    if (modalCoo) {
      modalCoo.style.display = 'none';
    }
    if (modalSuccess) {
      modalSuccess.style.display = 'none';
    }
    modalCooRequest.style.display = 'block';

    if (lotNumberInput && lotNumber) {
      lotNumberInput.setAttribute('value', lotNumber);
      lotNumberInput.setAttribute('readonly', true);
    }

    if (coaData) {
      if (coaData.CustomerNumber) {
        modal.querySelector('input[name="account_number"]').value = coaData.CustomerNumber;
      }
      if (coaData.Email) {
        modal.querySelector('input[name="email_address"]').value = coaData.Email;
      }
      if (coaData.RequestModalDescription) {
        requestDescription.innerHTML = coaData.RequestModalDescription;
        requestDescription;
      }
    }

    if (modal) {
      MicroModal.show(modalId, {
        openTrigger: 'data-generic-modal-open',
        closeTrigger: 'data-generic-modal-close',
        openClass: 'generic-modal--open',
        disableScroll: true,
        disableFocus: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onClose: () => {
          setTimeout(() => {
            if (modalSuccess) {
              modalSuccess.style.display = '';
            }
            if (modalCoo) {
              modalCoo.style.display = '';
            }
            modalCooRequest.style.display = '';
          }, 300);
        }
      });
    }
  }

  const handleClick = async event => {
    event.preventDefault();
    const lotNumber = event.target.closest('tr').children[1].textContent.trim();
    const coaEndpointElement = document.querySelector('.coa-api');
    const coaEndpoint = coaEndpointElement.getAttribute('data-endpoint');
    const coaDetailsEndpoint = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__container').getAttribute('data-endpoint');
    const modalElementID = 'modal-certificate-analysis-hepatocyte';
    const atccNumField = document.querySelector('input[name="atcc_catalog_number"]');
    try {
      const response = await axios.get(`${coaEndpoint}?Atcc_Number=${atccNumber}&lot_number=${lotNumber}`);
      if (response.data.body && response.data.body.path) {
        const filePath = response.data.body.path;
        window.open(filePath, '_blank');
      } else {
        MicroModal.close();
        const coaDataResponse = await axios.get(`${coaDetailsEndpoint}?Atcc_Number=${atccNumber}`);
        const coaData = coaDataResponse.data;
        customShowModal(modalElementID, lotNumber, coaData);
        atccNumField.value = atccNumber;
      }
    } catch (error) {
      MicroModal.close();
      customShowModal(modalElementID, lotNumber);
    }
  };

  const submitCoaRequest = async event => {
    event.preventDefault();

    const submitButton = event.target.querySelector('.modal-certificate-analysis-hepatocyte .btn--primary');

    const modalCoaRequestForm = event.target;
    const pristine = new Pristine(modalCoaRequestForm, PRISTINE_SETTINGS);
    const modal = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__coo-request');
    const modalMessage = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__error-message');

    const isValid = pristine.validate();

    if (isValid) {
      submitButton.disabled = true;

      const formData = serialize(modalCoaRequestForm, SERIALIZE_SETTINGS);
      const endpoint = modalCoaRequestForm.getAttribute('action') || null;
      const modalSuccess = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__success');

      try {
        const response = await axios.post(endpoint, formData, {
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const { success, message } = response.data;

        if (success) {
          console.log('success coA');
          modalSuccess.style.display = 'block';
          modalMessage.style.display = 'none';
          modal.style.display = 'none';
          submitButton.removeAttribute('disabled');
        } else {
          submitButton.disabled = false;
          modalMessage.innerHTML = message;
          modalMessage.style.display = 'block';
          console.log('error coA');
        }
      } finally {
        console.log('request-submited')
      }
    } else {
      submitButton.disabled = false;
      console.log('error coA failed');
    }
  };

  const resetCoaRequestForm = () => {
    const modalCoaRequestForm = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__form');
    const pristine = new Pristine(modalCoaRequestForm, PRISTINE_SETTINGS);

    try {
      modalCoaRequestForm.reset();
      pristine.reset();
    } catch (error) {
      return;
    }
  };

  const enableDisableBtn = () => {
    const parentForm = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__form');
    const submitButton = parentForm.querySelector('.btn');

    const isDisabled = false;
    if (!isDisabled){
      const RecaptchField = document.getElementById('recaptcha_field-coa');
      if (RecaptchField){
        RecaptchField.value = window.grecaptcha.getResponse();
      }
    }

    submitButton.removeAttribute('disabled');
  };

  useEffect(() => {
    const modalCoaRequestForm = document.querySelector('.modal-certificate-analysis-hepatocyte .modal-certificate-analysis__form');
    if (modalCoaRequestForm) {
      modalCoaRequestForm.addEventListener('submit', submitCoaRequest);
    }

    return () => {
      if (modalCoaRequestForm) {
        modalCoaRequestForm.removeEventListener('submit', submitCoaRequest);
      }
    };
  }, []);

  useEffect(() => {
    $('.generic-modal__overlay').removeAttr('data-generic-modal-close');
  }, []);

  return (
    <Fragment>
      {data?.map((item, index) => (
        <tr key={item.LotNumber}>
          <td>
            <input
              type="number"
              id={`quantity-${index}`}
              name="quantity"
              data-index={index}
              onChange={event => {
                handleQuantityUpdate(index, event.target.value);
                handleQuantityChange(event.target);
              }}
              onKeyDown={event => {
                if (event.key === '-' || event.key === 'e') {
                  event.preventDefault();
                }
              }}
            />
          </td>
          <td>
            <span>{item.LotNumber}</span>
          </td>
          <td>
            <span>{item.Inventory}</span>
          </td>
          <td>
            <span>{item.DonorAge}</span>
          </td>
          <td>
            <span>{item.DonorSex}</span>
          </td>
          <td>
            <span>{item.DonorEthnicity}</span>
          </td>
          <td>
            <span>{item.DonorBMI}</span>
          </td>
          <td>
            <span>
              <a href="#" className="coa-link" onClick={handleClick}>CoA</a>
            </span>
          </td>
        </tr>
      ))}
    </Fragment>
  );
};

export default SpecificlotinfoSearch;
